var PRIMEDirectives = angular.module("PRIMEDirectives", []);

PRIMEDirectives.directive("keypressEvents", [
	"$document",
	"$rootScope",
	function($document, $rootScope) {
		return {
			restrict: "A",
			link: function() {
			$document.bind("keypress", function(e) {
				$rootScope.$broadcast("keypress", e);
				$rootScope.$broadcast("keypress:" + e.which, e);
			});
		  }
		};
	}
]);

PRIMEDirectives.directive("draggable",['$document', function($document) {
	return function(scope, element, attr) {
		$(element).addClass(attr.draggable).draggable({
			handle: "img",
			helper: "clone",
			helper: function() {
				var originals = $(this).children();
				var helper = $(this).clone();
				var id;
				
				if (angular.element(this).scope().cohort)
					id = angular.element(this).scope().cohort._id;
				
				if (angular.element(this).scope().treatment)
					id = angular.element(this).scope().treatment._id;
				
				if (angular.element(this).scope().cost)
					id = angular.element(this).scope().cost._id;
				
				if (angular.element(this).scope().utility)
					id = angular.element(this).scope().utility._id;
			
				if (angular.element(this).scope().country)
					id = angular.element(this).scope().country._id;
				
				helper.data("id", id);
				helper.css({width:$(this).parent().width() + "px"});
				
				helper.children().each(function(index) {
					$(this).width(originals.eq(index).width());
				});
				
				return helper;
			},
			revert: "invalid",
			zIndex: 10000
		});
	}
}]);

PRIMEDirectives.directive("droppable",['$document', function($document) {
	return function(scope, element, attr) {
		$(element).droppable({
			accept: "." + attr.droppable,
			activeClass: "simulation-drag-target-drag-in-progress",
			hoverClass: "simulation-drag-target-hover",
			tolerance: "pointer",
			drop: function(event, ui) {
				$(this).addClass("simulation-drag-target-dropped");
				
				switch (scope.pane.id) {
				case "cohorts":
					scope.$apply(function () {
						scope.$parent.simulation.elements.cohortIDs[element[0].id.indexOf("-1") !== -1 ? 0 : 1] = $(ui.helper).data("id");
					});
					break;
				case "treatments":
					scope.$apply(function () {
						scope.$parent.simulation.elements.treatmentIDs[element[0].id.indexOf("-1") !== -1 ? 0 : 1] = $(ui.helper).data("id");
					});
					break;
				case "costs":
					scope.$apply(function () {
						scope.$parent.simulation.elements.costIDs[element[0].id.indexOf("-1") !== -1 ? 0 : 1] = $(ui.helper).data("id");
					});
					break;
				case "utilities":
					scope.$apply(function () {
						scope.$parent.simulation.elements.utilityIDs[element[0].id.indexOf("-1") !== -1 ? 0 : 1] = $(ui.helper).data("id");
					});
					break;
				case "countries":
					scope.$apply(function () {
						scope.$parent.simulation.elements.countryIDs[element[0].id.indexOf("-1") !== -1 ? 0 : 1] = $(ui.helper).data("id");
					});
					break;
				}
				
				$(this).find("p").html($(ui.draggable).find("td:nth-child(2)>a:first-child").text());
			}
		});
	}
}]);

PRIMEDirectives.directive('autoFocus', ['$timeout', function ($timeout) {
	return {
		restrict: 'A',
		
		link: function ($scope, $element, $attributes) {
			if ($scope.$eval($attributes.autoFocus) !== false) {
				var element = $element[0];
				
				$timeout(function() {
					$scope.$emit('focus', element);
					element.focus();
				});
			}
		}
	};
}])


// Force strings to display in "number" inputs when served as strings
PRIMEDirectives.directive('input', [function() {
	return {
		restrict: 'E',
		require: '?ngModel',
		link: function(scope, element, attrs, ngModel) {
			if (
				   'undefined' !== typeof attrs.type
				&& 'number' === attrs.type
				&& ngModel
			) {
				ngModel.$formatters.push(function(modelValue) {
					return Number(modelValue);
				});
				
				ngModel.$parsers.push(function(viewValue) {
					return Number(viewValue);
				});
			}
		}
	}
}]);


PRIMEDirectives.directive("tabs", function() {
	return {
		restrict: "E",
		transclude: true,
		scope: {},
		controller: function($scope, $element) {
			var panes = $scope.panes = [];

			$scope.select = function(pane) {
				angular.forEach(panes, function(pane) {
					pane.selected = false;
				});
				if (pane.load !== undefined) {
					pane.load();	
				}
				pane.selected = true;			
			}

			this.addPane = function(pane) {
				if (panes.length == 0) $scope.select(pane);
				panes.push(pane);
			}
		},
		template:
			'<div class="tabbable">' +
				'<ul class="nav nav-tabs">' +
					'<li ng-repeat="pane in panes" ng-class="{active:pane.selected}">'+
						'<a href="" ng-click="select(pane)">{{pane.tabTitle}}</a>' +
					'</li>' +
				'</ul>' +
				'<div class="tab-content" ng-transclude></div>' +
			'</div>',
		replace: true
    };
});
 
PRIMEDirectives.directive("pane", ["$http", "$templateCache", "$controller", "$compile", function($http, $templateCache, $controller, $compile) {
	return {
		require: "^tabs",
		restrict: "E",
		transclude: true,
		scope: { tabTitle: "@" },
		link: function(scope, element, attrs, tabsCtrl) {
			var templateCtrl, templateScope;

			if (attrs.template) {
				scope.load = function() {
					$http.get(attrs.template, {cache: $templateCache})
					.then(function(response) {
						templateScope = scope.$new();
						templateScope.isTabbedPane = true;
						templateCtrl = $controller(attrs.controller, {$scope: templateScope});
						element.html(response.data);
						element.children().data('$ngControllerController', templateCtrl);
						$compile(element.contents())(templateScope);
					});	
				}	
			}
			
			tabsCtrl.addPane(scope);
		},
		template:
	        '<div class="tab-pane" ng-class="{active: selected}" ng-transclude>' +
	        '</div>',
		replace: true
	};
}])